module.exports = __webpack_public_path__ + "img/product-tutorial-2.b310746d.png";